/**
=========================================================
* Kunta.live - v2.0
=========================================================

* Product Page: https://kunta.live
* Copyright 2025 Osmo Leppäniemi


 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
//import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// react-router components
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
//import { useQuery } from "@apollo/client";
// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import DefaultNavBar from "components/DefaultNavBar";
// Material Kit 2 React themes
import theme from "assets/theme";
import CookieConsent from "react-cookie-consent";
//import Presentation from "layouts/pages/presentation";
//import { useTranslation } from "react-i18next";
import Alku from "components/Alku";
import Organs from "./components/Organs";
import Organsadmin from "./components/Organsadmin";
//import OrganForm from "./components/OrganForm";
import Meeting from "./components/Meeting";
import Meetings from "./components/Meetings";
import Minut from "./components/Minut";
import Minuts from "./components/Minuts";
//import Minutes from "./components/Minutes";
import Minutesadmin from "./components/Minutesadmin";
import Minutadmin from "./components/Minutadmin";
import Meetingsadmin from "./components/Meetingsadmin";
import Strategycommentsadmin from "./components/Strategycommentsadmin";
import Budgetsadmin from "./components/Budgetadmin";
import Focusareasadmin from "./components/Focusareasadmin";
import SWOTadmin from "./components/SWOTadmin";
import Karttaadmin from "./components/Karttaadmin";
//import MeetingForm from "./components/MeetingForm";
import Initiatives from "./components/Initiatives";
import Initiativesadmin from "./components/Initiativesadmin";
//import Initiativespublic from "./components/Initiativespublic";
import Initiative from "./components/Initiative";
//import InitiativeForm from "./components/InitiativeForm";
import PersonForm from "./components/PersonForm";
//import ProposalForm from "./components/ProposalForm";
import Scraping from "./components/Scraping";
import Minutesscraping from "./components/Minutesscraping";
//import UserForm from "./components/UserForm";
import Users from "./components/Users";
import UserActivation from "./components/UserActivation";
//import LoginForm from "./components/LoginForm";
//import Logout from "./components/Logout";
//import Organ from "./components/Organ";
import UserRegistration from "./components/UserRegistration";
//import CommentForm from "./components/CommentForm";
import Comment from "./components/Comment";
import Commentsadmin from "./components/Commentsadmin";
//import Commentpublic from "./components/Commentpublic";
import Gdpr from "./components/Gdpr";
import Proposals from "./components/Proposals";
import Proposalsadmin from "./components/Proposalsadmin";
//import Proposalspublic from "./components/Proposalspublic";
import Municipalities from "./components/Municipalities";
import Faq from "./components/Faq";
import User from "./components/User";
import Admin from "./components/Admin";
import Strategy from "components/Strategy";
import Strategypublic from "components/Strategypublic";
//import LandCalculator from "components/LandCalculator";
//import Header from "./components/Header";
//import Headerpublic from "./components/Headerpublic";
//import Headeradmin from "./components/Headeradmin";
import Info from "./components/Info";
import Termsofuse from "./components/Termsofuse";
import Instructions from "./components/Instructions";
import Sections from "./components/Sections";
import Sectionsadmin from "./components/Sectionsadmin";
import Section from "./components/Section";
import LoginForm from "components/LoginForm";
//import Links from "./components/Links";
import Linksadmin from "./components/Linksadmin";
//import Linkspublic from "./components/Linkspublic";
//import LinkForm from "./components/LinkForm";
//import SectionForm from "./components/SectionForm";
import ForgetPassword from "components/ForgetPassword";
import NewPassword from "./components/NewPassword";
import NewProposal from "components/NewProposal";
//import NewInitiative from "components/NewInitiative";
// Material Kit 2 React routes
import routes from "routes";
import routes_en from "routes_en";
import routes_sv from "routes_sv";
import routes_admin from "routes_admin";
import routes_en_admin from "routes_en_admin";
import routes_sv_admin from "routes_sv_admin";
import routes_noadmin from "routes_noadmin";
import routes_en_noadmin from "routes_en_noadmin";
import routes_sv_noadmin from "routes_sv_noadmin";
import footerRoutes from "footer.routes";
import footerRoutessv from "footer.routes_sv";
import footerRoutesen from "footer.routes_en";
// eslint-disable-next-line
import kunnat from "kunnat";
import Profile from "components/Profile";
import Contact from "components/Contact";
import Usersadmin from "components/Usersadmin";
import { Button } from "@mui/material";
import NewInitiative from "components/NewInitiative";
import MKBox from "components/MKBox";
import DefaultFooter from "components/DefaultFooter";
//import { ALL_ORGANS } from "./queries";
import Minutes from "components/Minutes";
//import { Schedule } from "@mui/icons-material";
import Target from "components/Target";
import License from "components/License";
import Schedules from "components/Schedules";
//import TagManager from "react-gtm-module";
import { useApolloClient } from "@apollo/client";
import Sectionpublic from "components/Sectionpublic";
import Initiativespublic from "components/Initiativespublic";
import Idecide from "components/Idecide";
import "./App.css";
import Muniadmin from "components/Muniadmin";
import Strategyo from "components/Strategyo";
//import { useCookies } from "react-cookie";
//import { useLocation } from "react-router-dom";
//import { useAnalytics } from "@keiko-app/react-google-analytics";
//import { Token } from "graphql";
//import Information from "components/Information";

//import { useRadioGroup, Box, ButtonGroup, Button, FormControl, Checkbox, FormControlLabel, FormLabel, Radio, RadioGroup, Select, InputLabel, MenuItem, Slider, TextField } from "@mui/material";
/**
 * 
 * @returns 
 * <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Rakennustyyppi</InputLabel>
            <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={priceType}
                label="Age"
                onChange={(e) => setPriceType(e.target.value)}
            >
                <MenuItem value="kerros">Kerrostalo</MenuItem>
                <MenuItem value="teollisuus">Teollisuuslaitos</MenuItem>
                <MenuItem value="yritys">Yritys</MenuItem>
                <MenuItem value="rivi">Rivitalo</MenuItem>
                <MenuItem value="pientalo">Pientalo</MenuItem>
            </Select>
            </FormControl>
 */
//const [errorMessage, setErrorMessage] = useState("");

/*//console.log(errorMessage);
const notify = (message) => {
  setErrorMessage(message);
  setTimeout(() => {
    setErrorMessage(null);
  }, 5000);
};
//console.log(notify);
*/
export default function App() {
  /*const organsw = useQuery(ALL_ORGANS, {
    pollInterval: 100000,
  });

  let organss = [];
  let municipalitiess = [];
  if (organsw.data) {
    organss = organsw.data.allOrgans;
    //console.log(organss);
    //municipalitiess=organsw.data.allOrgans
  }*/
  const [cookies] = useState(Date.now());
  const [selected, setSelected] = useState("Kommentit");
  const [token, setToken] = useState("");
  //console.log(token);
  const [usertype, setUsertype] = useState(null);
  //const [userID, setUserID] = useState(null);
  const { pathname } = useLocation();
  //const [selectedKunta, setSelectedKunta] = useState("Siikainen"); // Valittu alue
  // Setting page scroll to 0 when changing the route
  const [selectedKunta, setSelectedKunta] = useState("Nakkila"); // Valittu alue
  const [user, setUser] = useState(null);
  // eslint-disable-next-line
  const [errorMessage, setErrorMessage] = useState(null);
  // eslint-disable-next-line
  const [log, setLogout] = useState(null);
  //console.log(errorMessage);
  //console.log(user);
  //console.log(log);
  //console.log(setLogout);
  //console.log(usertype);

  /*const login = (user) => {
    setUser(user)
    notify(`tervetuloa ${user}`)
    //setMessage(`tervetuloa ${user}`)
  }*/

  //useEffect(() => {
  //TagManager.initialize({ gtmId: "GTM-WCF466Q" });
  //}, []);
  //const [selectedLanguage, setSelectedLanguage] = useState("fi"); // Valittu alue
  //const sectionsss = "";
  //const miitings = "";
  //const miinutes = "";
  //  const minutessss = "";
  //const organss = "";
  const linkss = "";
  const votess = "";
  //const proposal = "";
  //const komments = "";
  //const organsw = "";
  //const initiativess = "";
  //const municipalitiess = "";
  //const userss = "";
  const { id } = useParams();
  const [t, i18n] = useTranslation("common");
  //console.log(t);
  /*const setUsertype = "";
  const log = "";
  const login = "";
  const setLogout = "";
  const setToken = "";
  const client = "";*/
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);
  /*useEffect(() => {
    i18n.changeLanguage(id);
    //console.log(t("menu.home"));
  }, []);
  */
  useEffect(() => {
    ReactGA.initialize(process.env.REACT_APP_GA4_MEASUREMENT_ID);
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
  //const location = useLocation();
  //const { tracker } = useAnalytics();
  const client = useApolloClient();
  useEffect(() => {
    document.title = "Kunta.live";
    const token = localStorage.getItem("daas-user-token");
    if (token) {
      setToken(token);
      //console.log(token);
    }
    const useri = localStorage.getItem("usertype");
    if (useri) {
      setUsertype(useri);
    }
    /*const userid = localStorage.getItem("userid");
    if (userid) {
      setUserID(userid);
    }*/
    const email = localStorage.getItem("email");
    if (email) {
      setUser(localStorage.getItem("email"));
    }
    /* ReactGA.event({
      category: "Open App",
      action: "Opening kunta.live",
      label: "Opening"
    })
    */
  }, []);
  useEffect(() => {
    /*ReactGA.event({
      category: selectedKunta,
      action: "strategy",
      value: window.location.pathname + "/" + selected, // optional
      //value: 99, // optional, must be a number
      //nonInteraction: true, // optional, true/false
      //transport: "xhr", // optional, beacon/xhr/image
    });
    */
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + "/" + selected + "/" + selectedKunta,
    });
    */
    ReactGA.event({
      category: "Button Clicks",
      action: "Click",
      label: "Strategy/" + selected + "/" + selectedKunta, // optional params
    });
  }, [selected]);

  const notify = (message) => {
    setErrorMessage(message);
    setTimeout(() => {
      setErrorMessage(null);
    }, 5000);
  };
  const getRoutes = (allRoutes) => {
    //console.log(allRoutes);
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.route) {
        //const comp = route.component.replace("/>", "");
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            /*comp +
            "selectedKunta={" +
            selectedKunta +
            "} setSelectedKunta={" +
            setSelectedKunta +
            "} />"
            }*/
            key={route.key}
          />
        );
      }

      return null;
    });
  };
  //console.log(kunnat);
  //console.log(selectedKunta);
  //console.log(i18n.language);
  if (i18n.language === "en" && token.length > 10 && usertype === "3") {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsent
          location="bottom"
          buttonText={t("common.accept")}
          cookieName="KuntaliveCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          {t("common.cookies")}
          <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
        </CookieConsent>
        <DefaultNavBar
          routes={routes_en_admin}
          action={{
            type: "internal",
            route: "/login/out",
            label: t("headers.logout"),
            color: "info",
          }}
          sticky
          selectedKunta={selectedKunta}
          setSelectedKunta={setSelectedKunta}
          token={token}
        />
        <div
          style={{
            right: "0px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
          }}
          height="20px"
        >
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("fi")}
          >
            fi
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("en")}
          >
            en
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("sv")}
          >
            sv
          </Button>
        </div>
        <Routes>
          <Route
            path="/"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/lng/:id"
            element={
              <Alku
                lng={id}
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/toimielimet"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" setError={notify} />} />
          <Route path="/faq" element={<Faq setError={notify} />} />
          <Route
            path="/agendas/:id"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutes/:id"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/muniadmin"
            element={<Muniadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/:chosenmunicipal"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/organs/select/:municipality"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes/select/:municipality"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/organsadmin" element={<Organsadmin setError={notify} />} />
          <Route
            path="/strategycommentsadmin"
            element={<Strategycommentsadmin setError={notify} />}
          />
          <Route path="/strategybudgetsadmin" element={<Budgetsadmin setError={notify} />} />
          <Route path="/strategyfocusareasadmin" element={<Focusareasadmin setError={notify} />} />
          <Route path="/strategyswotsadmin" element={<SWOTadmin setError={notify} />} />
          <Route path="/strategymapsadmin" element={<Karttaadmin setError={notify} />} />
          <Route
            path="/linksadmin"
            element={<Linksadmin links={linkss} setError={notify} votes={votess} />}
          />
          <Route
            path="/register"
            element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword/:id"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/scraping"
            element={<Scraping selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutesscraping"
            element={<Minutesscraping selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections/:id"
            element={<Section selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minute/:id"
            element={<Minut selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sectionsadmin"
            element={<Sectionsadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minuteadmin"
            element={<Minutadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/factcomments"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/commentsadmin"
            element={<Commentsadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings/organ/:chosenorgan"
            element={<Meeting selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/information"
            element={<Info selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/license"
            element={<License selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/target"
            element={<Target selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/schedule"
            element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings"
            selectedKunta={selectedKunta}
            setSelectedKunta={setSelectedKunta}
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings/select/:municipality"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetingsadmin"
            element={<Meetingsadmin setError={notify} selectedKunta={selectedKunta} />}
          />
          <Route
            path="/minutesadmin"
            element={<Minutesadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/testi"
            element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/comments/:id"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/proposals"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newproposal"
            element={
              <NewProposal
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/newinitiative"
            element={
              <NewInitiative
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/proposalsadmin"
            element={
              <Proposalsadmin
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/initiatives/:id" element={<Initiative setError={notify} />} />
          <Route
            path="/initiatives"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/select/:municipality"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiativesadmin"
            element={<Initiativesadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/votes"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/strategy"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route
            path="/strategy/:municipality"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route path="/gdpr" element={<Gdpr selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/municipalities"
            element={
              <Municipalities
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/municipalities/:id"
            element={<Organs selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/activation/:id"
            element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/users"
            element={<Users selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/admin"
            element={<Admin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/usersadmin" element={<Usersadmin setError={notify} />} />
          <Route path="/info" element={<Info selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/account"
            element={<User selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/profile"
            element={<Profile selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/contact"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/bugs"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/termsofuse"
            element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/instructions"
            element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/login/:logout"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/logout"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          {getRoutes(routes_en_admin)}
        </Routes>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutesen} selectedKunta={selectedKunta} setError={notify} />
        </MKBox>
      </ThemeProvider>
    );
  }
  if (i18n.language === "sv" && token.length > 10 && usertype === "3") {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsent
          location="bottom"
          buttonText={t("common.accept")}
          cookieName="KuntaliveCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          {t("common.cookies")}
          <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
        </CookieConsent>
        <DefaultNavBar
          routes={routes_sv_admin}
          action={{
            type: "internal",
            route: "/login/out",
            label: t("headers.logout"),
            color: "info",
          }}
          sticky
          selectedKunta={selectedKunta}
          setSelectedKunta={setSelectedKunta}
          token={token}
          setError={notify}
        />
        <div
          style={{
            right: "0px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
          }}
          height="20px"
        >
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("fi")}
          >
            fi
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("en")}
          >
            en
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("sv")}
          >
            sv
          </Button>
        </div>
        <Routes>
          <Route
            path="/"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/lng/:id"
            element={
              <Alku
                lng={id}
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/toimielimet"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" setError={notify} />} />
          <Route path="/faq" element={<Faq selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/muniadmin"
            element={<Muniadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutes"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes/select/:municipality"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/agendas/:id"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutes/:id"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/:chosenmunicipal"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/organs/select/:municipality"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/organsadmin"
            element={<Organsadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/linksadmin"
            element={<Linksadmin selectedKunta={selectedKunta} setError={notify} votes={votess} />}
          />
          <Route
            path="/strategycommentsadmin"
            element={<Strategycommentsadmin setError={notify} />}
          />
          <Route path="/strategybudgetsadmin" element={<Budgetsadmin setError={notify} />} />
          <Route path="/strategyfocusareasadmin" element={<Focusareasadmin setError={notify} />} />
          <Route path="/strategyswotsadmin" element={<SWOTadmin setError={notify} />} />
          <Route path="/strategymapsadmin" element={<Karttaadmin setError={notify} />} />
          <Route
            path="/register"
            element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword/:id"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/scraping" element={<Scraping setError={notify} />} />
          <Route path="/minutesscraping" element={<Minutesscraping setError={notify} />} />
          <Route
            path="/sections/:id"
            element={<Section selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minute/:id"
            element={<Minut selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/sectionsadmin" element={<Sectionsadmin setError={notify} />} />
          <Route path="/minuteadmin" element={<Minutadmin setError={notify} />} />
          <Route
            path="/factcomments"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/commentsadmin" element={<Commentsadmin setError={notify} />} />
          <Route
            path="/meetings/organ/:chosenorgan"
            element={<Meeting selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/information"
            element={<Info selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/license"
            element={<License selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/target"
            element={<Target selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/schedule"
            element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings/select/:municipality"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetingsadmin"
            element={<Meetingsadmin setError={notify} selectedKunta={selectedKunta} />}
          />
          <Route
            path="/minutesadmin"
            element={<Minutesadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/testi"
            element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/comments/:id"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/proposals"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newproposal"
            element={
              <NewProposal
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/proposalsadmin" element={<Proposalsadmin setError={notify} />} />
          <Route
            path="/initiatives/:id"
            element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/initiatives"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/select/:municipality"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/initiativesadmin" element={<Initiativesadmin setError={notify} />} />
          <Route
            path="/votes"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/strategy"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route
            path="/strategy/:municipality"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route path="/gdpr" element={<Gdpr />} />
          <Route
            path="/municipalities"
            element={
              <Municipalities
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/municipalities/:id"
            element={<Organs selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/activation/:id"
            element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/users"
            element={<Users selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/admin" element={<Admin setError={notify} />} />
          <Route path="/usersadmin" element={<Usersadmin setError={notify} />} />
          <Route path="/info" element={<Info selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/account"
            element={<User selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/profile"
            element={<Profile selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route path="/contact" element={<Contact user={user} setError={notify} />} />
          <Route
            path="/bugs"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/termsofuse"
            element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/instructions"
            element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/login/:logout"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route path="/logout" element={<Alku selectedKunta={selectedKunta} />} />
          {getRoutes(routes_sv_admin)}
        </Routes>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutessv} selectedKunta={selectedKunta} setError={notify} />
        </MKBox>
      </ThemeProvider>
    );
  }
  if (token.length > 10 && usertype === "3") {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsent
          location="bottom"
          buttonText={t("common.accept")}
          cookieName="KuntaliveCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          {t("common.cookies")}
          <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
        </CookieConsent>
        <DefaultNavBar
          routes={routes_admin}
          action={{
            type: "internal",
            route: "/login/out",
            label: t("headers.logout"),
            color: "info",
          }}
          sticky
          selectedKunta={selectedKunta}
          setSelectedKunta={setSelectedKunta}
          token={token}
          setError={notify}
        />
        <div
          style={{
            right: "0px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
          }}
          height="20px"
        >
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("fi")}
          >
            fi
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("en")}
          >
            en
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("sv")}
          >
            sv
          </Button>
        </div>
        <Routes>
          <Route
            path="/"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/osmostrategy"
            element={<Strategyo selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/lng/:id"
            element={
              <Alku
                lng={id}
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/toimielimet"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" setError={notify} />} />
          <Route path="/faq" element={<Faq selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/minutes"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes/select/:municipality"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/agendas/:id"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutes/:id"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/:chosenmunicipal"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/muniadmin"
            element={<Muniadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/select/:municipality"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/organsadmin" element={<Organsadmin setError={notify} />} />
          <Route path="/linksadmin" element={<Linksadmin setError={notify} votes={votess} />} />
          <Route
            path="/strategycommentsadmin"
            element={<Strategycommentsadmin setError={notify} />}
          />
          <Route path="/strategybudgetsadmin" element={<Budgetsadmin setError={notify} />} />
          <Route path="/strategyfocusareasadmin" element={<Focusareasadmin setError={notify} />} />
          <Route path="/strategyswotsadmin" element={<SWOTadmin setError={notify} />} />
          <Route path="/strategymapsadmin" element={<Karttaadmin setError={notify} />} />
          <Route
            path="/register"
            element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword/:id"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/scraping" element={<Scraping setError={notify} />} />
          <Route path="/minutesscraping" element={<Minutesscraping setError={notify} />} />
          <Route
            path="/sections/:id"
            element={<Section selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minute/:id"
            element={<Minut selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/sectionsadmin" element={<Sectionsadmin setError={notify} />} />
          <Route path="/minuteadmin" element={<Minutadmin setError={notify} />} />
          <Route
            path="/factcomments"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/commentsadmin" element={<Commentsadmin setError={notify} />} />
          <Route
            path="/information"
            element={<Info selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/license"
            element={<License selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/target"
            element={<Target selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/schedule"
            element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings/organ/:chosenorgan"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings/select/:municipality"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetingsadmin"
            element={<Meetingsadmin setError={notify} selectedKunta={selectedKunta} />}
          />
          <Route
            path="/minutesadmin"
            element={<Minutesadmin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/testi"
            element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/comments/:id"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/proposals"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newproposal"
            element={
              <NewProposal
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/proposalsadmin" element={<Proposalsadmin setError={notify} />} />
          <Route
            path="/initiatives/:id"
            element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/initiatives"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/select/:municipality"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/initiativesadmin" element={<Initiativesadmin setError={notify} />} />
          <Route
            path="/votes"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/strategy"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route
            path="/strategy/:municipality"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route path="/gdpr" element={<Gdpr setError={notify} />} />
          <Route
            path="/municipalities"
            element={
              <Municipalities
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/municipalities/:id"
            element={<Organs selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/activation/:id"
            element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/users"
            element={<Users selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/admin"
            element={<Admin selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/usersadmin" element={<Usersadmin setError={notify} />} />
          <Route path="/info" element={<Info selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/account"
            element={<User selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/profile"
            element={<Profile selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/contact"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/bugs"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/termsofuse"
            element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/instructions"
            element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/login/:logout"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/logout"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          {getRoutes(routes_admin)}
        </Routes>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} selectedKunta={selectedKunta} setError={notify} />
        </MKBox>
      </ThemeProvider>
    );
  }
  if (i18n.language === "en" && token.length > 10) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsent
          location="bottom"
          buttonText={t("common.accept")}
          cookieName="KuntaliveCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          {t("common.cookies")}
          <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
        </CookieConsent>
        <DefaultNavBar
          routes={routes_en_noadmin}
          action={{
            type: "internal",
            route: "/login/out",
            label: t("headers.logout"),
            color: "info",
          }}
          sticky
          selectedKunta={selectedKunta}
          setSelectedKunta={setSelectedKunta}
          token={token}
          setError={notify}
        />
        <div
          style={{
            right: "0px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
          }}
          height="20px"
        >
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("fi")}
          >
            fi
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("en")}
          >
            en
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("sv")}
          >
            sv
          </Button>
        </div>
        <Routes>
          <Route
            path="/"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/lng/:id"
            element={
              <Alku
                lng={id}
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/toimielimet"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" setError={notify} />} />
          <Route path="/faq" element={<Faq selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/agendas/:id"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutes/:id"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/:chosenmunicipal"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs"
            element={<Organs selectedKunta={selectedKunta} setSelectedKunta={setSelectedKunta} />}
          />
          <Route
            path="/organs/select/:municipality"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes"
            element={<Minutes selectedKunta={selectedKunta} setSelectedKunta={setSelectedKunta} />}
          />
          <Route
            path="/minutes/select/:municipality"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/register"
            element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword/:id"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections/:id"
            element={<Section selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minute/:id"
            element={<Minut selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/factcomments"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings/organ/:chosenorgan"
            element={<Meeting selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/information"
            element={<Info selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/license"
            element={<License selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/target"
            element={<Target selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/schedule"
            element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings"
            selectedKunta={selectedKunta}
            setSelectedKunta={setSelectedKunta}
            element={<Meetings selectedKunta={selectedKunta} setSelectedKunta={setSelectedKunta} />}
            setError={notify}
          />
          <Route
            path="/meetings/select/:municipality"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/testi"
            element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/comments/:id"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/proposals"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newproposal"
            element={
              <NewProposal
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/newinitiative"
            element={
              <NewInitiative
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/:id"
            element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/initiatives"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/select/:municipality"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/votes"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/strategy"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route
            path="/strategy/:municipality"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route path="/gdpr" element={<Gdpr selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/municipalities"
            element={
              <Municipalities
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/municipalities/:id"
            element={<Organs selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/activation/:id"
            element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/info" element={<Info selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/account"
            element={<User selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/profile"
            element={<Profile selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/contact"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/bugs"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/termsofuse"
            element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/instructions"
            element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/login/:logout"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/logout"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          {getRoutes(routes_en_noadmin)}
        </Routes>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutesen} selectedKunta={selectedKunta} setError={notify} />
        </MKBox>
      </ThemeProvider>
    );
  }
  if (i18n.language === "sv" && token.length > 10) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsent
          location="bottom"
          buttonText={t("common.accept")}
          cookieName="KuntaliveCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          {t("common.cookies")}
          <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
        </CookieConsent>
        <DefaultNavBar
          routes={routes_sv_noadmin}
          action={{
            type: "internal",
            route: "/login/out",
            label: t("headers.logout"),
            color: "info",
          }}
          sticky
          selectedKunta={selectedKunta}
          setSelectedKunta={setSelectedKunta}
          token={token}
          setError={notify}
        />
        <div
          style={{
            right: "0px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
          }}
          height="20px"
        >
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("fi")}
          >
            fi
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("en")}
          >
            en
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("sv")}
          >
            sv
          </Button>
        </div>
        <Routes>
          <Route
            path="/"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/lng/:id"
            element={
              <Alku
                lng={id}
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/toimielimet"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" setError={notify} />} />
          <Route path="/faq" element={<Faq selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/minutes"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes/select/:municipality"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/agendas/:id" element={<Sections selectedKunta={selectedKunta} />} />
          <Route
            path="/minutes/:id"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/:chosenmunicipal"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/organs/select/:municipality"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/register"
            element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword/:id"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections/:id"
            element={<Section selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minute/:id"
            element={<Minut selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/factcomments"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings/organ/:chosenorgan"
            element={<Meeting selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/information"
            element={<Info selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/license"
            element={<License selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/target"
            element={<Target selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/schedule"
            element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings/select/:municipality"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/testi"
            element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/comments/:id"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/proposals"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newproposal"
            element={
              <NewProposal
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/:id"
            element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/initiatives"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/select/:municipality"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/votes"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/strategy"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route
            path="/strategy/:municipality"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route path="/gdpr" element={<Gdpr selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/municipalities"
            element={
              <Municipalities
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/municipalities/:id"
            element={<Organs selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/activation/:id"
            element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/info" element={<Info selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/account"
            element={<User selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/profile"
            element={<Profile selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/contact"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/bugs"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/termsofuse"
            element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/instructions"
            element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/login/:logout"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/logout"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          {getRoutes(routes_sv_noadmin)}
        </Routes>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutessv} selectedKunta={selectedKunta} setError={notify} />
        </MKBox>
      </ThemeProvider>
    );
  }
  if (token.length > 10) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CookieConsent
          location="bottom"
          buttonText={t("common.accept")}
          cookieName="KuntaliveCookie"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          {t("common.cookies")}
          <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
        </CookieConsent>
        <DefaultNavBar
          routes={routes_noadmin}
          action={{
            type: "internal",
            route: "/login/out",
            label: t("headers.logout"),
            color: "info",
          }}
          sticky
          selectedKunta={selectedKunta}
          setSelectedKunta={setSelectedKunta}
          token={token}
          setError={notify}
        />
        <div
          style={{
            right: "0px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
          }}
          height="20px"
        >
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("fi")}
          >
            fi
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("en")}
          >
            en
          </Button>
          <Button
            style={{
              height: "20px",
              backgroundColor: "#9ADEDC",
              color: "#000000",
              fontSize: "14px",
            }}
            size="small"
            color="primary"
            onClick={() => i18n.changeLanguage("sv")}
          >
            sv
          </Button>
        </div>
        <Routes>
          <Route
            path="/"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/municipality/:municipality"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/lng/:id"
            element={
              <Alku
                lng={id}
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/toimielimet"
            element={
              <Alku
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="*" element={<Navigate to="/" setError={notify} />} />
          <Route path="/faq" element={<Faq selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/minutes"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/minutes/select/:municipality"
            element={
              <Minutes
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/agendas/:id"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minutes/:id"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs/:chosenmunicipal"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/organs"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/organs/select/:municipality"
            element={
              <Organs
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/register"
            element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/forgetpassword"
            element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword/:id"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newpassword"
            element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections/:id"
            element={<Section selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/minute/:id"
            element={<Minut selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/sections"
            element={<Sections selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/factcomments"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/information"
            element={<Info selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/license"
            element={<License selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/target"
            element={<Target selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/schedule"
            element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/meetings/organ/:chosenorgan"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/meetings/select/:municipality"
            element={
              <Meetings
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/testi"
            element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/comments/:id"
            element={<Comment selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/proposals"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/newproposal"
            element={
              <NewProposal
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/:id"
            element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/initiatives"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/initiatives/select/:municipality"
            element={
              <Initiatives
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route
            path="/votes"
            element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/strategy"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route
            path="/strategy/:municipality"
            element={
              <Strategy
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
                selected={selected}
                setSelected={setSelected}
              />
            }
          />
          <Route path="/gdpr" element={<Gdpr selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/municipalities"
            element={
              <Municipalities
                selectedKunta={selectedKunta}
                setSelectedKunta={setSelectedKunta}
                setError={notify}
              />
            }
          />
          <Route path="/idecide" element={<Idecide setError={notify} />} />
          <Route
            path="/municipalities/:id"
            element={<Organs selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/activation/:id"
            element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route path="/info" element={<Info selectedKunta={selectedKunta} setError={notify} />} />
          <Route
            path="/account"
            element={<User selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/profile"
            element={<Profile selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/contact"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/bugs"
            element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
          />
          <Route
            path="/termsofuse"
            element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/instructions"
            element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
          />
          <Route
            path="/login"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/login/:logout"
            element={
              <LoginForm
                setUsertype={setUsertype}
                usertype={usertype}
                setError={notify}
                setToken={setToken}
                client={client}
              />
            }
          />
          <Route
            path="/logout"
            element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
          />
          {getRoutes(routes_noadmin)}
        </Routes>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} selectedKunta={selectedKunta} setError={notify} />
        </MKBox>
      </ThemeProvider>
    );
  } else {
    if (i18n.language === "en") {
      return (
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <CookieConsent
            location="bottom"
            buttonText={t("common.accept")}
            cookieName="KuntaliveCookie"
            style={{ background: "#2B373B" }}
            buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
            expires={150}
          >
            {t("common.cookies")}
            <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
          </CookieConsent>
          <DefaultNavBar
            routes={routes_en}
            action={{
              type: "internal",
              route: "/login",
              label: t("headers.login"),
              color: "info",
            }}
            sticky
            selectedKunta={selectedKunta}
            setSelectedKunta={setSelectedKunta}
            token={token}
            setError={notify}
          />
          <div
            style={{
              right: "0px",
              position: "fixed",
              top: "90px",
              bottom: 0,
              height: "20px",
              color: "#C4DFE6",
              zIndex: 99,
            }}
            height="20px"
          >
            <Button
              style={{
                height: "20px",
                backgroundColor: "#9ADEDC",
                color: "#000000",
                fontSize: "14px",
              }}
              size="small"
              color="primary"
              onClick={() => i18n.changeLanguage("fi")}
            >
              fi
            </Button>
            <Button
              style={{
                height: "20px",
                backgroundColor: "#9ADEDC",
                color: "#000000",
                fontSize: "14px",
              }}
              size="small"
              color="primary"
              onClick={() => i18n.changeLanguage("en")}
            >
              en
            </Button>
            <Button
              style={{
                height: "20px",
                backgroundColor: "#9ADEDC",
                color: "#000000",
                fontSize: "14px",
              }}
              size="small"
              color="primary"
              onClick={() => i18n.changeLanguage("sv")}
            >
              sv
            </Button>
          </div>
          <Routes>
            <Route
              path="/"
              element={
                <Alku
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/municipality/:municipality"
              element={
                <Alku
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/lng/:id"
              element={
                <Alku
                  lng={id}
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/toimielimet"
              element={
                <Alku
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/newpassword"
              element={
                <NewPassword
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route path="*" element={<Navigate to="/" setError={notify} />} />
            <Route path="/faq" element={<Faq selectedKunta={selectedKunta} setError={notify} />} />
            <Route
              path="/agendas/:id"
              element={<Sections selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/minutes/:id"
              element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/organs/:chosenmunicipal"
              element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/organs"
              element={
                <Organs
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/organs/select/:municipality"
              element={
                <Organs
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/minutes"
              element={
                <Minutes
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/minutes/select/:municipality"
              element={
                <Minutes
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/register"
              element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/forgetpassword"
              element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/newpassword/:id"
              element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/newpassword"
              element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/sections/:id"
              element={<Sectionpublic selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/minute/:id"
              element={<Minut selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/sections"
              element={<Sections selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/factcomments"
              element={<Comment selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/meetings/organ/:chosenorgan"
              element={<Meeting selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/information"
              element={<Info selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/license"
              element={<License selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/target"
              element={<Target selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/schedule"
              element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/meetings"
              selectedKunta={selectedKunta}
              setSelectedKunta={setSelectedKunta}
              element={
                <Meetings selectedKunta={selectedKunta} setSelectedKunta={setSelectedKunta} />
              }
              setError={notify}
            />
            <Route
              path="/meetings/select/:municipality"
              element={
                <Meetings
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/testi"
              element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/comments/:id"
              element={<Comment selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/proposals"
              element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/initiatives/:id"
              element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/initiatives"
              element={
                <Initiativespublic
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/initiatives/select/:municipality"
              element={
                <Initiativespublic
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/activateuser"
              element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/votes"
              element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/strategy"
              element={
                <Strategypublic
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                  selected={selected}
                  setSelected={setSelected}
                  cookies={cookies}
                />
              }
            />
            <Route
              path="/strategy/:municipality"
              element={
                <Strategy
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                  selected={selected}
                  setSelected={setSelected}
                />
              }
            />
            <Route path="/idecide" element={<Idecide setError={notify} />} />
            <Route
              path="/gdpr"
              element={<Gdpr selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/municipalities"
              element={
                <Municipalities
                  selectedKunta={selectedKunta}
                  setSelectedKunta={setSelectedKunta}
                  setError={notify}
                />
              }
            />
            <Route
              path="/municipalities/:id"
              element={<Organs selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/activation/:id"
              element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/info"
              element={<Info selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/contact"
              element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
            />
            <Route
              path="/bugs"
              element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
            />
            <Route
              path="/termsofuse"
              element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/instructions"
              element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
            />
            <Route
              path="/login"
              element={
                <LoginForm
                  setUsertype={setUsertype}
                  usertype={usertype}
                  setError={notify}
                  setToken={setToken}
                  client={client}
                />
              }
            />
            {getRoutes(routes_en)}
          </Routes>
          <MKBox pt={6} px={1} mt={6}>
            <DefaultFooter
              content={footerRoutesen}
              selectedKunta={selectedKunta}
              setError={notify}
            />
          </MKBox>
        </ThemeProvider>
      );
    } else {
      if (i18n.language === "sv") {
        return (
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <CookieConsent
              location="bottom"
              buttonText={t("common.accept")}
              cookieName="KuntaliveCookie"
              style={{ background: "#2B373B" }}
              buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
              expires={150}
            >
              {t("common.cookies")}
              <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
            </CookieConsent>
            <DefaultNavBar
              routes={routes_sv}
              action={{
                type: "internal",
                route: "/login",
                label: t("headers.login"),
                color: "info",
              }}
              sticky
              selectedKunta={selectedKunta}
              setSelectedKunta={setSelectedKunta}
              token={token}
              setError={notify}
            />
            <div
              style={{
                right: "0px",
                position: "fixed",
                top: "90px",
                bottom: 0,
                height: "20px",
                color: "#C4DFE6",
                zIndex: 99,
              }}
              height="20px"
            >
              <Button
                style={{
                  height: "20px",
                  backgroundColor: "#9ADEDC",
                  color: "#000000",
                  fontSize: "14px",
                }}
                size="small"
                color="primary"
                onClick={() => i18n.changeLanguage("fi")}
              >
                fi
              </Button>
              <Button
                style={{
                  height: "20px",
                  backgroundColor: "#9ADEDC",
                  color: "#000000",
                  fontSize: "14px",
                }}
                size="small"
                color="primary"
                onClick={() => i18n.changeLanguage("en")}
              >
                en
              </Button>
              <Button
                style={{
                  height: "20px",
                  backgroundColor: "#9ADEDC",
                  color: "#000000",
                  fontSize: "14px",
                }}
                size="small"
                color="primary"
                onClick={() => i18n.changeLanguage("sv")}
              >
                sv
              </Button>
            </div>
            <Routes>
              <Route
                path="/"
                element={
                  <Alku
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/newpassword"
                element={
                  <NewPassword
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/municipality/:municipality"
                element={
                  <Alku
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/lng/:id"
                element={
                  <Alku
                    lng={id}
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/toimielimet"
                element={
                  <Alku
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route path="*" element={<Navigate to="/" setError={notify} />} />
              <Route path="/faq" element={<Faq setError={notify} />} />
              <Route
                path="/minutes"
                element={
                  <Minutes
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/minutes/select/:municipality"
                element={
                  <Minutes
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/agendas/:id"
                element={<Sections selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/minutes/:id"
                element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/organs/:chosenmunicipal"
                element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/organs"
                element={
                  <Organs
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/organs/select/:municipality"
                element={
                  <Organs
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/register"
                element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/forgetpassword"
                element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/newpassword/:id"
                element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/newpassword"
                element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/sections/:id"
                element={<Sectionpublic selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/minute/:id"
                element={<Minut selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/sections"
                element={<Sections selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/factcomments"
                element={<Comment selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/meetings/organ/:chosenorgan"
                element={<Meeting selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/information"
                element={<Info selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/license"
                element={<License selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/target"
                element={<Target selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/schedule"
                element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/meetings"
                element={
                  <Meetings
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/meetings/select/:municipality"
                element={
                  <Meetings
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route path="/idecide" element={<Idecide setError={notify} />} />
              <Route
                path="/testi"
                element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/comments/:id"
                element={<Comment selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/proposals"
                element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/initiatives/:id"
                element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/initiatives"
                element={
                  <Initiativespublic
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/initiatives/select/:municipality"
                element={
                  <Initiativespublic
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/votes"
                element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/strategy"
                element={
                  <Strategypublic
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                    selected={selected}
                    setSelected={setSelected}
                    cookies={cookies}
                  />
                }
              />
              <Route
                path="/activateuser"
                element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/strategy/:municipality"
                element={
                  <Strategy
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                    selected={selected}
                    setSelected={setSelected}
                  />
                }
              />
              <Route path="/gdpr" element={<Gdpr setError={notify} />} />
              <Route
                path="/municipalities"
                element={
                  <Municipalities
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/municipalities/:id"
                element={<Organs selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/activation/:id"
                element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/info"
                element={<Info selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/contact"
                element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
              />
              <Route
                path="/bugs"
                element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
              />
              <Route
                path="/termsofuse"
                element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/instructions"
                element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/login"
                element={
                  <LoginForm
                    setUsertype={setUsertype}
                    usertype={usertype}
                    setError={notify}
                    setToken={setToken}
                    client={client}
                  />
                }
              />
              {getRoutes(routes_sv)}
            </Routes>
            <MKBox pt={6} px={1} mt={6}>
              <DefaultFooter
                content={footerRoutessv}
                selectedKunta={selectedKunta}
                setError={notify}
              />
            </MKBox>
          </ThemeProvider>
        );
      } else {
        return (
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <CookieConsent
              location="bottom"
              buttonText={t("common.accept")}
              cookieName="KuntaliveCookie"
              style={{ background: "#2B373B" }}
              buttonStyle={{ color: "#4e503b", fontSize: "15px" }}
              expires={150}
            >
              {t("common.cookies")}
              <span style={{ fontSize: "12px" }}>{t("common.cookiessmall")}</span>
            </CookieConsent>
            <DefaultNavBar
              routes={routes}
              action={{
                type: "internal",
                route: "/login",
                label: t("headers.login"),
                color: "info",
              }}
              sticky
              selectedKunta={selectedKunta}
              setSelectedKunta={setSelectedKunta}
              token={token}
              setError={notify}
            />
            <div
              style={{
                right: "0px",
                position: "fixed",
                top: "90px",
                bottom: 0,
                height: "20px",
                color: "#C4DFE6",
                zIndex: 99,
              }}
              height="20px"
            >
              <Button
                style={{
                  height: "20px",
                  backgroundColor: "#9ADEDC",
                  color: "#000000",
                  fontSize: "14px",
                }}
                size="small"
                color="primary"
                onClick={() => i18n.changeLanguage("fi")}
              >
                fi
              </Button>
              <Button
                style={{
                  height: "20px",
                  backgroundColor: "#9ADEDC",
                  color: "#000000",
                  fontSize: "14px",
                }}
                size="small"
                color="primary"
                onClick={() => i18n.changeLanguage("en")}
              >
                en
              </Button>
              <Button
                style={{
                  height: "20px",
                  backgroundColor: "#9ADEDC",
                  color: "#000000",
                  fontSize: "14px",
                }}
                size="small"
                color="primary"
                onClick={() => i18n.changeLanguage("sv")}
              >
                sv
              </Button>
            </div>
            <Routes>
              <Route
                path="/"
                element={
                  <Alku
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/newpassword"
                element={
                  <NewPassword
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/municipality/:municipality"
                element={
                  <Alku
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route path="/idecide" element={<Idecide setError={notify} />} />
              <Route
                path="/lng/:id"
                element={
                  <Alku
                    lng={id}
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/toimielimet"
                element={
                  <Alku
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route path="*" element={<Navigate to="/" setError={notify} />} />
              <Route
                path="/faq"
                element={<Faq selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/minutes"
                element={
                  <Minutes
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/minutes/select/:municipality"
                element={
                  <Minutes
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/useractivation/select/:content"
                element={
                  <Minutes
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/agendas/:id"
                element={<Sections selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/activateuser"
                element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/minutes/:id"
                element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/organs/:chosenmunicipal"
                element={<Minuts selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/organs"
                element={
                  <Organs
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/organs/select/:municipality"
                element={
                  <Organs
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/register"
                element={<UserRegistration selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/forgetpassword"
                element={<ForgetPassword selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/newpassword/:id"
                element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/newpassword"
                element={<NewPassword selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/sections/:id"
                element={<Sectionpublic selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/minute/:id"
                element={<Minut selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/sections"
                element={<Sections selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/factcomments"
                element={<Comment selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/information"
                element={<Info selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/license"
                element={<License selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/target"
                element={<Target selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/schedule"
                element={<Schedules selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/meetings/organ/:chosenorgan"
                element={
                  <Meetings
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/meetings"
                element={
                  <Meetings
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/meetings/select/:municipality"
                element={
                  <Meetings
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/testi"
                element={<PersonForm selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/comments/:id"
                element={<Comment selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/proposals"
                element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/initiatives/:id"
                element={<Initiative selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/initiatives"
                element={
                  <Initiativespublic
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/initiatives/select/:municipality"
                element={
                  <Initiativespublic
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/votes"
                element={<Proposals selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/strategy"
                element={
                  <Strategypublic
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                    selected={selected}
                    setSelected={setSelected}
                    cookies={cookies}
                  />
                }
              />
              <Route
                path="/strategy/:municipality"
                element={
                  <Strategy
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                    selected={selected}
                    setSelected={setSelected}
                  />
                }
              />
              <Route
                path="/gdpr"
                element={<Gdpr selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/municipalities"
                element={
                  <Municipalities
                    selectedKunta={selectedKunta}
                    setSelectedKunta={setSelectedKunta}
                    setError={notify}
                  />
                }
              />
              <Route
                path="/municipalities/:id"
                element={<Organs selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/activation/:id"
                element={<UserActivation selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/info"
                element={<Info selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/contact"
                element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
              />
              <Route
                path="/bugs"
                element={<Contact selectedKunta={selectedKunta} user={user} setError={notify} />}
              />
              <Route
                path="/termsofuse"
                element={<Termsofuse selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/instructions"
                element={<Instructions selectedKunta={selectedKunta} setError={notify} />}
              />
              <Route
                path="/login"
                element={
                  <LoginForm
                    setUsertype={setUsertype}
                    usertype={usertype}
                    setError={notify}
                    setToken={setToken}
                    client={client}
                  />
                }
              />
              {getRoutes(routes)}
            </Routes>
            <MKBox pt={6} px={1} mt={6}>
              <DefaultFooter
                content={footerRoutes}
                selectedKunta={selectedKunta}
                setError={notify}
              />
            </MKBox>
          </ThemeProvider>
        );
      }
    }
  }
}
